import { render } from "./telephone.vue?vue&type=template&id=58815f98&scoped=true"
import script from "./telephone.vue?vue&type=script&lang=js"
export * from "./telephone.vue?vue&type=script&lang=js"

import "./telephone.vue?vue&type=style&index=0&id=58815f98&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58815f98"]])

export default __exports__